import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Post } from '../../types/post';

export interface PostsState {
  posts: Record<number, Post[]>;
}

const initialState: PostsState = {
  posts: {},
};

const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    setPosts: (state, action: PayloadAction<{ communityId: number; posts: Post[] }>): void => {
      const { communityId, posts } = action.payload;
      state.posts[communityId] = posts;
    },
    updatePost: (state, action: PayloadAction<{ communityId: number; post: Post }>): void => {
      const { communityId, post } = action.payload;
      if (!state.posts[communityId]) return;
      state.posts[communityId] = state.posts[communityId].map((p) =>
        p.postId === post.postId ? post : p,
      );
    },
    removePost: (state, action: PayloadAction<{ communityId: number; postId: number }>): void => {
      const { communityId, postId } = action.payload;
      if (!state.posts[communityId]) return;
      state.posts[communityId] = state.posts[communityId].filter((p) => p.postId !== postId);
    },
    patchPostReactions: (
      state,
      action: PayloadAction<{ communityId: number; postId: number; reactions: Post['reactions'] }>,
    ): void => {
      const { communityId, postId, reactions } = action.payload;
      if (!state.posts[communityId]) return;
      const post = state.posts[communityId].find((p) => p.postId === postId);
      if (post) post.reactions = reactions;
    },
    patchPostCommentsCount: (
      state,
      action: PayloadAction<{ communityId: number; postId: number; commentsCount: number }>,
    ): void => {
      const { communityId, postId, commentsCount } = action.payload;
      if (!state.posts[communityId]) return;
      const post = state.posts[communityId].find((p) => p.postId === postId);
      if (post) post.commentsCount = commentsCount;
    },
  },
});

const postsReducer = postsSlice.reducer;

export const { setPosts, updatePost, removePost, patchPostReactions, patchPostCommentsCount } =
  postsSlice.actions;
export default postsReducer;
